import React from "react";
import ReactDOM from "react-dom/client";
import AppEntry from "./AppEntry";
import "./index.css";
import logger from './utils/logger';
import "./utils/chartSetup";

// WATERMARK: Build ID for deployment verification
window.__BUILD__ = process.env.REACT_APP_BUILD_SHA;
console.log('WATERMARK:build', window.__BUILD__);

// Add global error handler
window.addEventListener("error", (event) => {
  logger.error("GLOBAL ERROR:", {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
  });
});

// Add unhandled promise rejection handler
window.addEventListener("unhandledrejection", (event) => {
  logger.error("UNHANDLED PROMISE REJECTION:", {
    reason: event.reason,
    promise: event.promise,
  });
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppEntry />
  </React.StrictMode>
);
